import { IVwRestricoesAlimentares } from '@/types/views/IVwRestricoesAlimentares';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

export class ViewRestricoesAlimentaresService extends BaseMultiTenantService<IVwRestricoesAlimentares> {
  constructor() {
    super('vw_restricoes_alimentares', ['nome_produto', 'descricao_produto', 'observacoes'], 'fk_id_organizacao');
  }
}

export const viewRestricoesAlimentares = new ViewRestricoesAlimentaresService();
